module.exports = __webpack_public_path__ + "img/icon-calendar.02c13a08.svg";